import React, { PropTypes } from 'react';

import { findDOMNode } from 'react-dom';
import { flow } from "lodash";
import { DragSource, DropTarget } from 'react-dnd';

// eslint-disable-next-line
Array.prototype.move = function (from, to) {
	this.splice(to, 0, this.splice(from, 1)[0]);
};

function findNode(id, currentNode) {
	var i,
		currentChild,
		result;

	if (id === currentNode.id) {
		return currentNode;
	} else {

		// Use a for loop instead of forEach to avoid nested functions
		// Otherwise "return" will not work properly
		for (i = 0; currentNode.children !== undefined && i < currentNode.children.length; i += 1) {
			currentChild = currentNode.children[i];

			// Search in the current child
			result = findNode(id, currentChild);

			// Return the result if the node has been found
			if (result !== false) {
				return result;
			}
		}

		// The node has not been found and we have no more options
		return false;
	}
}

// Originalmente, funcionaria com drag and drop.
// Mas, por limitação de tempo, implementei movimentação por botões.
// Por isso o nome "Draggable"
export class DraggableLayer extends React.Component {
	
	findInLayers(layerId) {
		let lrs = { children: this.props.layers };
		let pai = this.props.pai ? findNode(this.props.pai.id, lrs) : lrs;
		
		let posAtual = pai.children.findIndex((l) => { return l.id === layerId; });

		return { pai, posAtual, lrs };
	}

	checkboxOrExpand(class2add) {
		const { layer } = this.props;
		let type = layer.children ? 'expand' : 'check';
		if (type === 'check') {
			return (
				<div className='layer'>
					<input type='checkbox' className={`${class2add}`} id={layer.codename} name={layer.codename} />
					<label htmlFor={layer.codename} >{layer.name}</label>
					{this.reorderLayer(layer.id)}
				</div>
			);
		} else if (type === 'expand') { 
			return (
				<div className='layer'>
					<button type='button' className={`collapsible ${class2add}`} 
							onClick={this.onClickExpander.bind(this, layer)}>{layer.name}
					</button>
					{this.reorderLayer(layer.id)}
				</div>
				
			);
		}
	}

	reorderLayer(layerId) {
		let pai, posAtual;
		
		({ pai, posAtual } = this.findInLayers(layerId));
		let childrenlength = pai.children.length - 1;

		return (
			<div className='acoes'>
				
				{posAtual > 0 ? <i 
					className="fas fa-arrow-up pointer hoverable" 
					data-tip="Mover para cima" 
					onClick={this.cima.bind(this, layerId)}
				/> : null}

				{posAtual < childrenlength ? <i 
					className="fas fa-arrow-down pointer hoverable" 
					data-tip="Mover para baixo" 
					onClick={this.baixo.bind(this, layerId)}
				/> : null}
			</div>
		);
	}

	cima(layerId) {
		let lrs, pai, posAtual;
		
		({ pai, posAtual, lrs } = this.findInLayers(layerId));

		let novaPos = posAtual > 0 ? posAtual - 1 : 0;
		pai.children.move(posAtual, novaPos);
		
		this.props.setMapLayers(lrs.children);
	}

	baixo(layerId) {
		let lrs, pai, posAtual;
		
		({ pai, posAtual, lrs } = this.findInLayers(layerId));
		let novaPos = posAtual < pai.children.length ? posAtual + 1 : posAtual;
		pai.children.move(posAtual, novaPos);
		
		this.props.setMapLayers(lrs.children);
	}

	onClickExpander(e) {
		this.props.changeOneMapLayer(e.id, !e.openOrCheck);
	}

	render() {
		// const { layer, isDragging, connectDragSource, connectDropTarget, mapLayers } = this.props;		
		const { layer } = this.props;		
	
		let _class = '';
		let class2add = '';
		if (layer.openOrCheck) { 
			_class = 'content open';
			class2add = 'active';
		} else { 
			_class = 'content close';
		}

		return (
			<div className="row boxCamada">
				<div key={layer.id}>
					{this.checkboxOrExpand(layer, class2add)}
					<div className={_class}>
						{layer.children ? layer.children.map((child, i) => 
							<DraggableLayer 
								key={i}
								index={i}
								pai={layer}
								layer={child}
								layers={this.props.layers}
								changeOneMapLayer={this.props.changeOneMapLayer}
								setMapLayers={this.props.setMapLayers}
								connectDragSource={this.props.connectDragSource}
								connectDropTarget={this.props.connectDropTarget}
							/> ) : null}
					</div>
				</div>	
			</div>
		);

		// return connectDragSource(connectDropTarget(
		// 	<div className="row boxCamada" style={{ ...style, opacity }}>

		// 		<div key={layer.id}>
		// 			{this.checkboxOrExpand(layer, class2add)}
		// 			<div className={_class}>
		// 				{layer.children ? layer.children.map((child, i) => 
		// 					<DraggableLayer 
		// 						key={i}
		// 						index={i}
		// 						layer={child}
		// 						changeOneMapLayer={this.props.changeOneMapLayer}
		// 						connectDragSource={this.props.connectDragSource}
		// 						connectDropTarget={this.props.connectDropTarget}
		// 					/> ) : null}
		// 			</div>
		// 		</div>
			
		// 	</div>
		// ));
	}

}

DraggableLayer.propTypes = {
	layer: PropTypes.object.isRequired,
	index: PropTypes.number.isRequired,
	pai: PropTypes.object,
	layers: PropTypes.array.isRequired,
	changeOneMapLayer: PropTypes.func.isRequired,
	setMapLayers: PropTypes.func.isRequired,
	// moveLayer: PropTypes.func.isRequired,
	connectDragSource: PropTypes.func.isRequired,
	connectDropTarget: PropTypes.func.isRequired,
	isDragging: PropTypes.bool.isRequired
};

const layerSource = {
	beginDrag(props) {		
		return { index: props.index };
	}
};

const layerTarget = {
	hover(props, monitor, component) {
		const dragIndex = monitor.getItem().index;
		const hoverIndex = props.index;

		// Don't replace items with themselves
		if ( dragIndex === hoverIndex ) return;

		// Determine rectangle on screen
		const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

		// Get vertical middle
		const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

		// Determine mouse position
		const clientOffset = monitor.getClientOffset();

		// Get pixels to the top
		const hoverClientY = clientOffset.y - hoverBoundingRect.top;

		// Only perform the move when the mouse has crossed half of the items height
		// When dragging downwards, only move when the cursor is below 50%
		// When dragging upwards, only move when the cursor is above 50%

		// Dragging downwards
		if ( dragIndex < hoverIndex && hoverClientY < hoverMiddleY ) return;

		// Dragging upwards
		if ( dragIndex > hoverIndex && hoverClientY > hoverMiddleY ) return;

		// Time to actually perform the action
		// props.moveLayer(dragIndex, hoverIndex, props.layers[dragIndex]);

		// Note: we're mutating the monitor item here!
		// Generally it's better to avoid mutations,
		// but it's good here for the sake of performance
		// to avoid expensive index searches.
		monitor.getItem().index = hoverIndex;
	}
};

export default flow(
	DropTarget("DRAGGABLE_LAYER", layerTarget, connect => ({
		connectDropTarget: connect.dropTarget()
	})),
	DragSource("DRAGGABLE_LAYER", layerSource, (connect, monitor) => ({
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging()
	}))
)(DraggableLayer);


// WEBPACK FOOTER //
// ./src/components/ManageMaplayer/DraggableLayer.js